export const accessOverviewContent = `# Access & Paywall SDK

**What it does**

* **Login** and **Sign-up** forms (optionally collect payment at sign-up).
* **Entitlement check** for protected pages.
* **Automatic Paywall** when the current user is not entitled.

Designed for React + Supabase. Add a provider, use two auth helpers, and wrap paid pages with a \`ProtectedRoute\`. If the user isn't entitled, the SDK shows a paywall (sign in / sign up / checkout) and unlocks access when the purchase succeeds.

**Core objects**

* **App** – Your product instance (\`appSlug\`) configured in Lightswitch.
* **Publishable Key** – Public key used on the frontend.
* **Entitlement** – A boolean feature flag (e.g., \`has_access\`).
* **Paywall** – A modal that gates protected content and routes users to sign-in/sign-up/checkout.

**At a glance**

\`\`\`bash
npm i lightswitch-js
\`\`\`

\`\`\`tsx
import { LightswitchProvider, ProtectedRoute } from "lightswitch-js";
import { supabase } from "@/integrations/supabase/client";

<LightswitchProvider
  publishableKey="pk_flow-state-app"
  appSlug="flow-state-app"
  supabaseClient={supabase}
  autoShowPaywall={true}
/>
\`\`\``;
